import { Flex, FormCheckbox, mergeSx, type FormCheckboxProps } from '@shared/components';
import { useController, type FieldValues } from 'react-hook-form';

export default function SubTopicSelection<TFieldValues extends FieldValues = FieldValues>(
  props: Readonly<FormCheckboxProps<TFieldValues>>,
) {
  const { sx, slotProps, ...restProps } = props;

  const {
    field: { value },
  } = useController({
    name: props.name,
    control: props.control,
    rules: props.rules,
    defaultValue: props.defaultValue,
  });

  return (
    <Flex
      sx={(theme) => ({
        p: theme.spacing(3, 4, 3, 0),
      })}
    >
      <FormCheckbox
        {...restProps}
        checked={value}
        sx={mergeSx(
          (theme) => ({
            color: theme.palette.grey[400],
            p: theme.spacing(0),
            '&.Mui-disabled': {
              color: theme.palette.grey[300],
            },
          }),
          sx,
        )}
        slotProps={{
          formControlLabel: {
            ...slotProps?.formControlLabel,
            sx: mergeSx(
              (theme) => ({
                gap: theme.spacing(4),
                flex: 1,
              }),
              slotProps?.formControlLabel?.sx,
            ),
          },
          typography: {
            variant: 'body2',
            ...slotProps?.typography,
            sx: {
              '&.MuiFormControlLabel-label.Mui-disabled': {
                color: 'inherit',
              },
            },
          },
        }}
      />
    </Flex>
  );
}
